var map = {
	"./": "e05d",
	"./createFile": "128a",
	"./createFile.js": "128a",
	"./deleteFile": "ce78",
	"./deleteFile.js": "ce78",
	"./getFile": "d0e5",
	"./getFile.js": "d0e5",
	"./index": "e05d",
	"./index.js": "e05d",
	"./readLocalFile": "3908",
	"./readLocalFile.js": "3908",
	"./replaceFile": "3ab7",
	"./replaceFile.js": "3ab7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5126";